import {
  getFormattedContentInstreamPositionLabel,
  getFormattedContentOutstreamPositionLabel,
  getFormattedOnScreenPositionLabel
} from '../../../../lineItemHelpers'

import { targetingTypes } from '../../../LineItemDv360Create/fields'

export const getFormattedOnScreenPositionOptions = targeting => {
  const onScreenPositionTargeting = targeting.filter(
    item => item.type === targetingTypes.TARGETING_TYPE_ON_SCREEN_POSITION
  )

  return onScreenPositionTargeting.map(option => {
    const value = option.on_screen_position
    const label = getFormattedOnScreenPositionLabel(value)

    return {
      label,
      value,
      targetingOptionId: option.assigned_targeting_option_id
    }
  })
}

export const getFormattedContentInstreamPositionOptions = targeting => {
  const instreamPositionTargeting = targeting.filter(
    item => item.type === targetingTypes.TARGETING_TYPE_CONTENT_INSTREAM_POSITION
  )

  return instreamPositionTargeting.map(option => {
    const value = option.content_instream_position
    const label = getFormattedContentInstreamPositionLabel(value)

    return {
      label,
      value,
      targetingOptionId: option.assigned_targeting_option_id
    }
  })
}

export const getFormattedContentOutstreamPositionOptions = targeting => {
  const outstreamPositionTargeting = targeting.filter(
    item => item.type === targetingTypes.TARGETING_TYPE_CONTENT_OUTSTREAM_POSITION
  )

  return outstreamPositionTargeting.map(option => {
    const value = option.content_outstream_position
    const label = getFormattedContentOutstreamPositionLabel(value)

    return {
      label,
      value,
      targetingOptionId: option.assigned_targeting_option_id
    }
  })
}
